module.exports = __webpack_public_path__ + "img/swap.fc475ddb.svg";